// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../cf-fe-build-20260905/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../cf-fe-build-20260905/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainLoading_container__spqFp {
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: rgba(0, 0, 0, 0.3);
	height: 100%;
	width: 100%;
	z-index: 30000;
}
`, "",{"version":3,"sources":["webpack://./src/components/loadings/mainLoading/mainLoading.module.css"],"names":[],"mappings":"AAAA;CACC,eAAe;CACf,QAAQ;CACR,SAAS;CACT,gCAAgC;CAChC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,oCAAoC;CACpC,YAAY;CACZ,WAAW;CACX,cAAc;AACf","sourcesContent":[".container {\n\tposition: fixed;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tbackground-color: rgba(0, 0, 0, 0.3);\n\theight: 100%;\n\twidth: 100%;\n\tz-index: 30000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `mainLoading_container__spqFp`
};
export default ___CSS_LOADER_EXPORT___;
